import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';

new ScrollHint(".js-scrollable", {
    remainingTime: '4000',
    suggestiveShadow: true,
    i18n: {
      scrollable: "スクロールできます"
    }
});
